<template>
  <div class="editor-important__edit-wrapper">
    <EditorEditButton icon="editor/delete" @click="emit('delete')" />
  </div>
</template>

<script setup>
const emit = defineEmits(['delete']);
</script>
